import React, { ReactNode } from "react";
import { IFilestackCustomRenderProps, IFilestackOnSuccessProps } from "./misc";

const FILESTACK_API_KEY = "Aqw4lvamTSKiw8gSzioEKz";

let FilestackReact: any;

if (typeof window !== "undefined") {
  // eslint-disable-next-line
  // @ts-ignore
  FilestackReact = require("filestack-react").default;
}

interface IFilestackProps {
  onSuccess: (onSuccessProps: IFilestackOnSuccessProps) => void;
  customRender: (renderProps: IFilestackCustomRenderProps) => ReactNode;
  options?: any;
}

export default function Filestack({ onSuccess, customRender, options }: IFilestackProps) {
  return (
    <FilestackReact
      apikey={process.env.FILESTACK_API_KEY || FILESTACK_API_KEY}
      onSuccess={onSuccess}
      customRender={customRender}
      actionOptions={options}
    />
  );
}
